//@flow
import { compose, lifecycle } from 'recompose'
import { ModalBody, ModalHeader, Button } from 'reactstrap'
import { connect } from 'react-redux'

import { Modal } from 'common-components/index'
import type { AppState } from 'quick-quote/reducers'
import { setAppValue } from '../../../apps/actions'
import { getCurrentApp } from 'e-submission/apps/selectors'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import { confirmUsingRemoteSelling, clearRMSResults } from 'core/actions'

class NewRemoteSellingPreviewInfo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isSkipEkyc: false,
    }
  }

  render() {
    const { isOpen, hasPayer, insured, payer, confirmCreateRMS, clearRMSResults, onExit } = this.props
    return (
      <Modal
        className={'insured-and-payer-details-confirmations-modal'}
        isOpen={isOpen}
        size="md"
        modalClassName="default-bootstrap remote-selling-modal"
      >
        <ModalHeader className={'header-modal'} style={{ textAlign: 'center' }}>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              boxSizing: 'content-box',
              width: '70vw',
            }}
          >
            <p style={{ textAlign: 'center', marginBottom: '0rem' }}>กรุณาตรวจสอบความถูกต้อง</p>
            <p style={{ textAlign: 'center', marginBottom: '0rem' }}>อีกครั้งก่อนกดยืนยัน</p>
          </div>
          <Button
            className="close"
            onClick={onExit}
            type="button"
            style={{ fontSize: '1.5rem', position: 'absolute', right: '15px', top: '5px' }}
          >
            &times;
          </Button>
        </ModalHeader>
        <ModalBody>
          <div className={'flex-container'} style={{ display: 'flex', justifyContent: 'start' }}>
            <div style={{ textAlign: 'left', paddingLeft: '30px' }}>
              <p style={{ 'font-weight': 'bold', 'margin-bottom': '0rem' }}>ชื่อผู้เอาประกัน</p>
              ชื่อ: {insured.firstName}
              <br />
              นามสกุล: {insured.lastName}
              <br />
              {insured.citizenIdLabel}: {insured.citizenId}
            </div>
          </div>
          <div className={'normal-text detail-text modal-title'} style={{ color: '#2425aa' }}></div>
          {hasPayer ? (
            <div>
              <div className={'flex-container'} style={{ display: 'flex', justifyContent: 'start' }}>
                <div style={{ textAlign: 'left', paddingLeft: '30px' }}>
                  <p style={{ 'font-weight': 'bold', 'margin-bottom': '0rem' }}>ชื่อผู้ชำระเบี้ยประกัน</p>
                  ชื่อ: {payer.firstName}
                  <br />
                  นามสกุล: {payer.lastName}
                  <br />
                  {payer.citizenIdLabel}: {payer.citizenId}
                </div>
              </div>
              <div className={'normal-text detail-text modal-title'} style={{ color: '#2425aa' }}></div>
            </div>
          ) : null}
          <div className={'normal-text'}>
            <Link to={'insured'}>
              <Button
                className="back-button"
                onClick={() => {
                  clearRMSResults()
                }}
              >
                แก้ไข
              </Button>
            </Link>
            <Button
              color={'primary'}
              onClick={() => {
                confirmCreateRMS()
                onExit()
              }}
              className="primary"
            >
              ยืนยัน
            </Button>
          </div>
        </ModalBody>
      </Modal>
    )
  }
}

const mapStateToEkycPreviewInfoModal = (state: AppState, props) => {
  const app = getCurrentApp(state)
  const hasPayer = _.get(app, `payer.firstName`, false) ? true : false
  const isInsuredForeigner = _.get(app, `insured.idType.value`, '') === 'PASSPORT'
  const isPayerForeigner = _.get(app, `payer.idType.value`, '') === 'PASSPORT'
  const insured = {
    firstName: _.get(app, `insured.firstName`, 'xxx'),
    lastName: _.get(app, `insured.lastName`, 'xxx'),
    citizenId: isInsuredForeigner
      ? _.get(app, `insured.foreigner.passport`, 'xxx')
      : _.get(app, `insured.idNo.citizenId`, 'xxx'),
    citizenIdLabel: isInsuredForeigner ? 'เลขหนังสือเดินทาง' : 'เลขประจำตัวประชาชน',
  }
  const payer = {
    firstName: _.get(app, `payer.firstName`, 'xxx'),
    lastName: _.get(app, `payer.lastName`, 'xxx'),
    citizenId: isPayerForeigner ? _.get(app, `payer.idNo.passport`, 'xxx') : _.get(app, `payer.idNo.citizenId`, 'xxx'),
    citizenIdLabel: isPayerForeigner ? 'เลขหนังสือเดินทาง' : 'เลขประจำตัวประชาชน',
  }
  return {
    hasPayer,
    insured,
    payer,
  }
}

const mapDispatchToEkycPreviewInfoModal = (dispatch: Dispatch<*>, props) => ({
  confirmCreateRMS: () => {
    dispatch(confirmUsingRemoteSelling())
  },
  clearRMSResults: () => {
    dispatch(clearRMSResults())
  },
})

export default compose(
  connect(mapStateToEkycPreviewInfoModal, mapDispatchToEkycPreviewInfoModal),
  lifecycle({
    componentDidMount() {},
    componentDidUpdate(prevProps) {},
    componentWillReceiveProps(nextProps) {},
  })
)(NewRemoteSellingPreviewInfo)
